import materialIcons from "./icons"
import * as sasiIconsSvg from "assets/icons/sasi"
import * as businessIconsSvg from "assets/icons/business"
const sasiIcons = Object.keys(sasiIconsSvg).map(key => `sasi:${key}`)
const businessIcons = Object.keys(businessIconsSvg).map(key => `business:${key}`)
export default [...sasiIcons, ...businessIcons, ...materialIcons];
